import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../../actions/';
import Fiadores from '../../components/fiadores/fiadores';

const mapStateToProps = (state, ownProps) => {
    return state.fiadores;
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getDadosFormFiadores(){
            dispatch(actions.getDadosFormFiadores());
        },
        setIndexAbaFiador(index){
            dispatch(actions.setIndexAbaFiador(index));
        }
    };
};

const FiadoresContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Fiadores);


export default FiadoresContainer;


// WEBPACK FOOTER //
// ./src/containers/fiadores/fiadores.js